import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Error as SchemaError } from '../schemas/Error';
import { type SimilarCards as SchemaSimilarCards } from '../schemas/SimilarCards';
import { type SimilarCardsCreateCommand as SchemaSimilarCardsCreateCommand } from '../schemas/SimilarCardsCreateCommand';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags SimilarCards
 * @summary Создать настройки похожих карточек для карточки товара
 */
export const CreateSimilarCardsContentType = 'application/json' as const;
export type CreateSimilarCardsRequest = SchemaSimilarCardsCreateCommand;
export type CreateSimilarCardsResponses = LinkCommonErrorResponses & {
    /**
     * @description Настройки созданы
     */
    '201': {
        'application/json': SchemaSimilarCards;
    };
    /**
     * @description Настройки уже существуют
     */
    '409': {
        'application/json': SchemaError;
    };
};
export type CreateSimilarCardsResponseSuccess = undefined;
export type CreateSimilarCardsSearchParams = undefined;
export type CreateSimilarCardsPathParameters = {
    card_id: string;
};
export const CreateSimilarCardsUrl = '/cards/{card_id}/similar-cards' as const;
export const CreateSimilarCardsMethod = 'POST' as const;
export const getCreateSimilarCardsUrl = (params: CreateSimilarCardsPathParameters) =>
    CreateSimilarCardsUrl.replace(/\{(\w+)\}/g, (_match, param: keyof CreateSimilarCardsPathParameters) =>
        String(params[param])
    );
